<template>
    <div>
        <b-row>
            <b-col cols="6" sm="4" md="3" lg="2">
                <b-form-group class="mb-0">
                    <b-button variant="primary" block @click="getReport">
                        {{ $t('get_report') }}
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import qs from 'qs'

import StudentReportService from "@/services/StudentReportService";

export default {
    name: "allSlotAnalysisReport",
    data() {
        return {
            filter: {}
        }
    },
    methods: {
        async getReport() {
            const config = {
                params: {
                    filter: this.filter
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            StudentReportService.allSlotAnalysisReport(config)
                .then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                })
                .catch(err => this.showErrors(err))
        },
        clear() {
            this.filter = {}
        }
    }
}
</script>


<style lang="scss" scoped>
.form-group {
    .btn {
        line-height: 22px
    }
}
</style>
